module.exports = __webpack_public_path__ + "img/CTL.43d522f2.jpg";